import { useEffect, useState } from "react";

import { usePreferencias } from "@/hooks/usePreferencias";
import { alCambiarElSistema, hayQueEstarQuieto, sistemaPideMenos } from "@/lib/movimiento.mjs";

/**
 * ¿Hay que estar quieto en esta pantalla?
 *
 * La regla vive en `lib/movimiento.mjs` —manda el alumno, y solo si dice «como el sistema» se
 * le pregunta al sistema— y aquí solo se junta con React. Antes cada pantalla preguntaba
 * `prefers-reduced-motion` por su cuenta y se olvidaba del ajuste, así que «Movimiento:
 * completo» no hacía nada y «reducido» solo paraba el CSS.
 *
 * ESCUCHA EL CAMBIO DEL SISTEMA, y no es un lujo: en un Mac se activa «Reducir movimiento»
 * desde el panel de accesibilidad con la web abierta, y una consulta leída una sola vez al
 * montar deja la pantalla moviéndose hasta que alguien recargue. Quien lo enciende suele
 * hacerlo justo porque le está molestando lo que ve en ese momento.
 */
export function useQuieto() {
  const [prefs] = usePreferencias();
  const [sistema, setSistema] = useState(sistemaPideMenos);
  useEffect(() => alCambiarElSistema(setSistema), []);
  return hayQueEstarQuieto(prefs, sistema);
}

export default useQuieto;
